import { cn } from "@mozioinc/ui";
import type { AnchorHTMLAttributes, DetailedHTMLProps } from "react";

export type LinkProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  color?: "inherit" | "primary" | "secondary";
};

export const Link = (props: LinkProps) => {
  const { className = "inherit", color, ...others } = props;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      className={cn(
        "cursor-pointer underline hover:brightness-90",
        {
          "text-primary": color === "primary",
          "text-secondary": color === "secondary",
          "text-inherit": color === "inherit",
        },
        className,
      )}
      {...others}
    />
  );
};
